<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div
          class="
                        w-100
                        d-lg-flex
                        align-items-center
                        justify-content-center
                        px-5
                    "
        >
          <b-img
            fluid
            :src="imgUrl"
            :alt="$t('pages.registrationIllustration')"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title class="mb-50">
            {{ $t('pages.joinPrimeEarn') }}
          </b-card-title>
          <b-card-text class="mb-3">
            {{ $t('pages.monetizeYourAppWithPrimeGamesSurveys') }}
          </b-card-text>

          <!-- form -->
          <validation-observer
            ref="registerForm"
          >
            <b-form
              class="auth-register-form mt-2"
              @submit.prevent="register"
            >
              <!-- First Name -->
              <b-form-group
                :label="$t('pages.firstName')"
                label-for="register-first-name"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.firstName')"
                  vid="first_name"
                  rules="required"
                >
                  <b-form-input
                    id="register-first-name"
                    v-model="firstName"
                    name="register-first-name"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('pages.enterFirstName')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Last Name -->
              <b-form-group
                :label="$t('pages.lastName')"
                label-for="register-last-name"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.lastName')"
                  vid="last_name"
                  rules="required"
                >
                  <b-form-input
                    id="register-last-name"
                    v-model="lastName"
                    name="register-last-name"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('pages.enterLastName')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Company -->
              <b-form-group
                :label="$t('pages.companyName')"
                label-for="register-company"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.company')"
                  vid="company"
                  rules="required"
                >
                  <b-form-input
                    id="register-company"
                    v-model="company"
                    name="register-company"
                    :state="
                      errors.length > 0 ? false : null
                    "
                    :placeholder="$t('pages.yourCompany')"
                  />
                  <small class="text-danger">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Company Country -->
              <b-form-group
                :label="$t('pages.companyCountry')"
                label-for="register-country"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('dashboard.country')"
                  vid="country"
                  rules="required"
                >
                  <b-form-select
                    id="register-country"
                    v-model="country"
                    :options="countries"
                    text-field="name"
                    value-field="code"
                    :state="errors.length > 0 ? false : null"
                  >
                    <template #first>
                      <b-form-select-option
                        :value="null"
                        disabled
                      >
                        {{ $t('pages.selectACountry') }}
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Company City -->
              <b-form-group
                :label="$t('pages.companyCity')"
                label-for="register-city"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.city')"
                  vid="city"
                  rules="required"
                >
                  <b-form-input
                    id="register-city"
                    v-model="city"
                    name="register-city"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('pages.enterCity')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Company Email -->
              <b-form-group
                :label="$t('pages.companyEMail')"
                label-for="register-email"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.companyEMail')"
                  vid="email"
                  rules="required|email|company_email"
                >
                  <b-form-input
                    id="register-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('pages.enterEmail')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group
                label-for="register-password"
                :label="$t('pages.password')"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.password')"
                  vid="password"
                  :rules="{ required: true, min: 8, max: 15 }"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="
                      errors.length > 0
                        ? 'is-invalid'
                        : null
                    "
                  >
                    <b-form-input
                      id="register-password"
                      v-model="password"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      :state="
                        errors.length > 0 ? false : null
                      "
                      name="register-password"
                      :placeholder="$t('pages.enterPassword')"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIcon"
                        class="cursor-pointer"
                        @click="
                          togglePasswordVisibility
                        "
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>

              <!-- App/Website URL -->
              <b-form-group
                :label="$t('pages.appWebsiteUrl')"
                label-for="register-app-url"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.appUrl')"
                  vid="App URL"
                  rules="required|url"
                >
                  <b-form-input
                    id="register-app-url"
                    v-model="appWebsiteUrl"
                    :state="errors.length ? false : null"
                    :placeholder="$t('pages.enterUrl')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <br v-show="errors.length">
                </validation-provider>
                <small class="text-muted">{{ $t('pages.enterTheUrlOfTheAppWebsiteYouWould') }}</small>
              </b-form-group>

              <hr style="border-top: 1px solid #E5E7EB !important; margin: 2rem 0 2rem;">

              <!-- Is App Live -->
              <b-form-group :label="$t('pages.isYourAppLive')">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.appLive')"
                  vid="is_app_live"
                  rules="required_bool"
                >
                  <b-form-radio-group
                    v-model="isAppLive"
                    class="d-flex"
                  >
                    <b-form-radio :value="false">
                      {{ $t('apps.no') }}
                    </b-form-radio>
                    <b-form-radio :value="true">
                      {{ $t('pages.yes') }}
                    </b-form-radio>
                  </b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Platforms -->
              <b-form-group :label="$t('pages.whichPlatformsIsYourAppOn')">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.platforms')"
                  vid="platforms"
                  rules="required"
                >
                  <b-form-checkbox-group
                    v-model="platforms"
                    :options="platformOptions"
                    class="checkbox-group-spaced"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Google Play Store URL (Android) -->
              <b-form-group
                v-if="isAndroidSelected"
                :label="$t('pages.googlePlayStoreUrlAndroid')"
                label-for="register-google-play-url"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.googlePlayStoreUrl')"
                  vid="google_play_url"
                  rules="required|url"
                >
                  <b-form-input
                    id="register-google-play-url"
                    v-model="googlePlayUrl"
                    :state="errors.length ? false : null"
                    placeholder="https://play.google.com/store/apps/details?id=..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Apple App Store URL (iOS) -->
              <b-form-group
                v-if="isIosSelected"
                :label="$t('pages.appleAppStoreUrlIos')"
                label-for="register-apple-app-store-url"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.appleAppStoreUrl')"
                  vid="apple_app_store_url"
                  rules="required|url"
                >
                  <b-form-input
                    id="register-apple-app-store-url"
                    v-model="appleAppStoreUrl"
                    :state="errors.length ? false : null"
                    placeholder="https://apps.apple.com/app/..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- App Genre -->
              <b-form-group
                :label="$t('pages.whatIsYourAppGenre')"
                label-for="register-app-genre"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.appGenre')"
                  vid="app_genre"
                  rules="required"
                >
                  <b-form-select
                    id="register-app-genre"
                    v-model="appGenre"
                    :options="appGenreOptions"
                    :state="errors.length > 0 ? false : null"
                  >
                    <template #first>
                      <b-form-select-option
                        :value="null"
                        disabled
                      >
                        {{ $t('pages.selectAGenre') }}
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Daily Active Users -->
              <b-form-group
                :label="$t('pages.dailyActiveUsersDau')"
                label-for="register-dau"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.dailyActiveUsers')"
                  vid="daily_active_users"
                  rules="required|integer|min_value:0"
                >
                  <b-form-input
                    id="register-dau"
                    v-model="dailyActiveUsers"
                    type="number"
                    min="0"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('pages.eG5000')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Top Geographies -->
              <b-form-group
                :label="$t('pages.top5Geographies')"
                label-for="register-top-geographies"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.topGeographies')"
                  vid="top_geographies"
                  rules="required|max_selections:5"
                >
                  <v-select
                    id="register-top-geographies"
                    v-model="topGeographies"
                    :options="countries"
                    :reduce="option => option.code"
                    label="name"
                    multiple
                    :close-on-select="false"
                    :selectable="() => topGeographies.length < 5"
                    :placeholder="$t('pages.searchAndSelectCountries')"
                    :accessible-label="$t('pages.searchAndSelectCountries')"
                  >
                    <template #no-options>
                      {{ $t('common.noOptions') }}
                    </template>
                  </v-select>
                  <small class="text-muted">{{ $t('pages.selectUpTo5Countries') }}</small>
                  <br>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Monetization Solutions -->
              <b-form-group :label="$t('pages.whatMonetizationSolutionsDoYouCurrentlyUse')">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.monetizationSolutions')"
                  vid="monetization_solutions"
                  rules="required"
                >
                  <b-form-checkbox-group
                    v-model="monetizationSolutions"
                    :options="monetizationOptions"
                    class="checkbox-group-spaced"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <hr style="border-top: 1px solid #E5E7EB !important; margin: 2rem 0 2rem;">

              <!-- Survey Monetization Selection -->
              <b-form-group
                :label="$t('pages.doYouWorkWithOtherSurveyMonetizationSolutions')"
                class="optional"
              >
                <b-form-radio-group
                  v-model="usesSurveyMonetization"
                  class="d-flex"
                >
                  <b-form-radio :value="false">
                    {{ $t('apps.no') }}
                  </b-form-radio>
                  <b-form-radio :value="true">
                    {{ $t('pages.yes') }}
                  </b-form-radio>
                </b-form-radio-group>
              </b-form-group>

              <!-- Existing Survey Monetization Solutions (Hidden if "No" is selected) -->
              <b-form-group
                v-if="usesSurveyMonetization"
                :label="$t('pages.whichSurveyMonetizationSolutionsDoYouWorkWithAlready')"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.surveyMonetizationSolutions')"
                  vid="Survey Monetization Solutions"
                  rules="required"
                >
                  <b-form-textarea
                    id="register-survey-solutions"
                    v-model="existingSurveySolutions"
                    :state="errors.length ? false : null"
                    :placeholder="$t('pages.listYourSurveyPartners')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Highest Monthly Revenue (Manual Numeric Validation) -->
              <b-form-group
                v-if="usesSurveyMonetization"
                :label="$t('pages.whatSTheHighestMonthlyRevenueYouAchievedWith')"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.highestMonthlyRevenue')"
                  vid="Highest Monthly Revenue"
                  rules="required|revenue_numeric"
                >
                  <b-form-input
                    id="register-revenue"
                    v-model="highestMonthlyRevenue"
                    type="text"
                    :placeholder="$t('pages.enterInUsd')"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <div
                v-if="!usesSurveyMonetization"
                style="margin-bottom: 6rem;"
              />

              <hr style="border-top: 1px solid #E5E7EB; margin: 2rem 0 2rem;">

              <!-- Terms & Conditions -->
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  :name="$t('pages.terms')"
                  vid="terms"
                  rules="accepted"
                >
                  <div class="d-flex align-items-center justify-content-center">
                    <b-form-checkbox v-model="acceptedTerms">
                      <i18n
                        path="pages.acceptTerms"
                        tag="span"
                        class="ml-25"
                      >
                        <b-link
                          slot="terms"
                          :to="{ name: 'page-terms-and-conditions' }"
                          target="_blank"
                        >
                          {{ $t('pages.publisherTermsConditions') }}
                        </b-link>
                      </i18n>
                    </b-form-checkbox>
                  </div>
                  <small class="text-danger d-block text-center">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                variant="primary"
                block
                type="submit"
              >
                {{ $t('pages.signUp') }}
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <i18n
              path="pages.signInPrompt"
              tag="span"
            >
              <b-link
                slot="link"
                :to="{ name: 'page-login' }"
              >
                {{ $t('pages.signInInstead') }}
              </b-link>
            </i18n>
          </p>
        </b-col>
      </b-col>
      <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
import i18n from '@/libs/i18n'

/* eslint-disable global-require */
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BButton,
  BCardText,
  BCardTitle,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BRow,
} from 'bootstrap-vue'
import vSelect from '@/main/custom-components/LocalizedSelect'
import {
  email, required, url, min, max, integer,
} from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

extend('company_email', {
  validate: value => {
    const forbiddenDomains = ['gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com']
    const domain = value.split('@')[1]
    return !forbiddenDomains.includes(domain?.toLowerCase())
  },
  message: (field, parameters) => i18n.t('pages.pleaseUseYourCompanyEmailAddress', { ...parameters, _field_: field }),
})

extend('revenue_numeric', {
  validate: value => {
    const revenuePattern = /^[0-9]+(\.[0-9]{1,2})?$/
    return revenuePattern.test(value)
  },
  message: (field, parameters) => i18n.t('pages.pleaseEnterAValidNumericValueEG1000', { ...parameters, _field_: field }),
})

extend('required_bool', {
  validate: value => value === true || value === false,
  computesRequired: true,
  message: (field, parameters) => i18n.t('pages.thisFieldIsRequired', { ...parameters, _field_: field }),
})

extend('max_selections', {
  validate: (value, { length }) => Array.isArray(value) && value.length <= Number(length),
  params: ['length'],
  message: (field, parameters) => i18n.t('pages.youCanSelectUpToOptions', { ...parameters, _field_: field }),
})

extend('min_value', {
  validate: (value, { min: minValue }) => Number(value) >= Number(minValue),
  params: ['min'],
  message: (field, parameters) => i18n.t('pages.theMustBeOrMore', { ...parameters, _field_: field }),
})

extend('accepted', {
  validate: value => value === true,
  message: (field, parameters) => i18n.t('pages.youMustAcceptTheTermsConditionsToContinue', { ...parameters, _field_: field }),
})

export default {
  components: {
    VuexyLogo,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      firstName: '',
      lastName: '',
      company: '',
      userEmail: '',
      password: '',
      appWebsiteUrl: '',
      googlePlayUrl: '',
      appleAppStoreUrl: '',
      country: null,
      city: '',
      isAppLive: null,
      platforms: [],
      appGenre: null,
      dailyActiveUsers: null,
      topGeographies: [],
      monetizationSolutions: [],
      usesSurveyMonetization: false,
      existingSurveySolutions: null,
      highestMonthlyRevenue: null,
      acceptedTerms: false,
      countries: [],
      platformOptions: [
        { value: 'android', get text() { return i18n.t('pages.android') } },
        { value: 'ios', get text() { return i18n.t('pages.ios') } },
        { value: 'web', get text() { return i18n.t('pages.web') } },
        { value: 'other', get text() { return i18n.t('logs.other') } },
      ],
      appGenreOptions: [
        { value: 'rewards', get text() { return i18n.t('apps.rewards') } },
        { value: 'fintech', get text() { return i18n.t('pages.fintech') } },
        { value: 'cashback', get text() { return i18n.t('pages.cashback') } },
        { value: 'loyalty', get text() { return i18n.t('pages.loyalty') } },
        { value: 'gaming', get text() { return i18n.t('pages.gaming') } },
        { value: 'lifestyle', get text() { return i18n.t('pages.lifestyle') } },
        { value: 'other', get text() { return i18n.t('logs.other') } },
      ],
      monetizationOptions: [
        { value: 'surveys', get text() { return i18n.t('logs.surveys') } },
        { value: 'gaming', get text() { return i18n.t('pages.gaming') } },
        { value: 'offerwall', get text() { return i18n.t('apps.offerwall') } },
        { value: 'cashback', get text() { return i18n.t('pages.cashback') } },
        { value: 'ads', get text() { return i18n.t('pages.ads') } },
        { value: 'other', get text() { return i18n.t('logs.other') } },
      ],
      sideImg: require('@/assets/images/pages/register-v2.svg'),
      // validation
      required,
      email,
      url,
      min,
      max,
      integer,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password'
        ? 'EyeIcon'
        : 'EyeOffIcon'
    },
    imgUrl() {
      if (this.$store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/register-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
    isAndroidSelected() {
      return this.platforms.includes('android')
    },
    isIosSelected() {
      return this.platforms.includes('ios')
    },
  },
  watch: {
    usesSurveyMonetization(newVal) {
      if (!newVal) {
        this.existingSurveySolutions = null
        this.highestMonthlyRevenue = null
      }
    },
    platforms(newVal) {
      if (!newVal.includes('android')) this.googlePlayUrl = ''
      if (!newVal.includes('ios')) this.appleAppStoreUrl = ''
    },
  },
  created() {
    if (this.$store.getters['auth/isLoggedIn']) {
      this.$router.push({ path: '/' })
      return
    }
    this.fetchCountries()
  },
  methods: {
    normalizeUrl(rawUrl) {
      return /^https?:\/\//i.test(rawUrl) ? rawUrl : `https://${rawUrl}`
    },
    async fetchCountries() {
      try {
        const { data } = await this.$http.get('/api/countries')
        this.countries = data
      } catch (error) {
        this.countries = []
        this.alertError(i18n.t('pages.couldNotLoadTheCountryListPleaseRefreshAnd'))
      }
    },
    async register() {
      const isValid = await this.$refs.registerForm.validate()

      if (isValid) {
        this.showLoading()

        const websiteUrl = this.normalizeUrl(this.appWebsiteUrl)

        this.$http
          .post('/api/auth/register', {
            first_name: this.firstName,
            last_name: this.lastName,
            email: this.userEmail,
            password: this.password,
            company: this.company,
            website_url: websiteUrl,
            country: this.country,
            city: this.city,
            is_using_other_survey_monetization: this.usesSurveyMonetization,
            other_monetization: this.existingSurveySolutions,
            other_monetization_monthly_revenue: this.highestMonthlyRevenue,
            is_app_live: this.isAppLive,
            platforms: this.platforms,
            google_play_url: this.isAndroidSelected ? this.normalizeUrl(this.googlePlayUrl) : null,
            apple_app_store_url: this.isIosSelected ? this.normalizeUrl(this.appleAppStoreUrl) : null,
            app_genre: this.appGenre,
            daily_active_users: Number(this.dailyActiveUsers),
            top_geographies: this.topGeographies,
            monetization_solutions: this.monetizationSolutions,
          }, {
          })
          .then(response => {
            const { data } = response

            if (data.success) {
              this.alertSuccess(data.message || i18n.t('pages.registeredSuccessfullyPleaseWaitForApproval'))

              setTimeout(() => {
                // Pass the email to the login page as a query param
                this.$router.push({
                  path: '/pages/login',
                  query: { email: this.userEmail },
                })
              }, 2000)
            }
          })
          .catch(error => {
            const data = this.apiErrorData(error, i18n.t('pages.registrationFailed'))
            if (data && typeof data === 'object' && data.errors) {
              this.$refs.registerForm.setErrors(data.errors)
            } else {
              this.alertError(data)
            }
          })
          .finally(() => {
            this.hideLoading()
          })
      } else {
        // Surface what's missing: scroll to the first field showing an error
        this.$nextTick(() => {
          const firstError = [...this.$el.querySelectorAll('small.text-danger')]
            .find(el => el.textContent.trim().length)
          if (firstError) {
            const target = firstError.closest('.form-group') || firstError
            target.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
      }
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
@import "@core/scss/vue/libs/vue-select.scss";

// Give wrapped checkbox options breathing room between rows
.checkbox-group-spaced .custom-control {
  margin-bottom: 0.5rem;
}

// Mark required fields with a red asterisk on their label/legend
.auth-register-form .form-group > label::after,
.auth-register-form .form-group > legend::after {
  content: " *";
  color: #ea5455;
}
.auth-register-form .form-group.optional > label::after,
.auth-register-form .form-group.optional > legend::after {
  content: "";
}
</style>
